// src/app/features/passkey/services/device-id.ts
export const DEVICE_ID_KEY = 'axon-deviceId';

export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
